function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNodearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.797,
    height: 6.903,
    viewBox: "0 0 2.063 1.826",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M104.096 147.442c-.11 0-.188.134-.133.23l.881 1.525c.055.095.21.095.265 0l.881-1.526c.055-.095-.023-.229-.132-.229z",
    fill: "#c6c7fc",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-103.945 -147.442)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNodearrow);
export default __webpack_public_path__ + "static/media/icons-nodearrow.f2d9bd4a7a8d3b3e45c52d0821018ccf.svg";
export { ForwardRef as ReactComponent };